const saverconfig: any = {
	main_url: "https://api.clueso.io",
	// main_url: "http://localhost:8080",
	// main_url: "https://preprod.clueso.io",
};

export default saverconfig;
